import React from 'react';

const VerticalDropIcon = () => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="2"
    viewBox="0 0 26 26"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="22px"
    width="22px"
  >
    <path d="m7 15 5 5 5-5"></path>
    <path d="m7 9 5-5 5 5"></path>
  </svg>
);
export default VerticalDropIcon;
